(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-utility"] && !Shopify.designMode) return;
  try {
    
class UtilityPages extends HTMLElement {
  connectedCallback() {
    // Ensure only one FAQ accordion row is open at a time within this section (exclude mobile nav accordion)
    const group = this.closest('[data-accordion-group]') || this;
    const detailsList = Array.from(group.querySelectorAll('accordion-custom:not([data-nav-accordion="true"]) details'));

    detailsList.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) {
          detailsList.forEach((other) => {
            if (other !== details && other.open) other.open = false;
          });
        }
      });
    });
  }
}
if (!customElements.get('utility-pages')) customElements.define('utility-pages', UtilityPages);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["release-day-information"] && !Shopify.designMode) return;
  try {
    
  class ReleaseDayInformation extends HTMLElement {
    connectedCallback() {
      this.syncHeaderOffset();
      window.addEventListener('resize', this.syncHeaderOffset, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.syncHeaderOffset);
    }

    syncHeaderOffset = () => {
      const header = document.querySelector('#header-group #header-component');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      this.style.setProperty('--sticky-header-offset', `${Math.round(headerHeight)}px`);
    }
  }

  customElements.define('release-day-information', ReleaseDayInformation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wine-locator"] && !Shopify.designMode) return;
  try {
    
class WineLocator extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('#wine-locator-form');
    this.results = this.querySelector('#wine-locator-results');
    this.list = this.querySelector('#wine-locator-list');
    this.summary = this.querySelector('#wine-locator-summary');
    this.help = this.querySelector('#wine-locator-help');

    this.form?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleSubmit();
    });

    this.querySelector('#wine-locator-edit')?.addEventListener('click', () => {
      this.toggleViews(true);
    });

    this.querySelector('#wine-locator-new')?.addEventListener('click', () => {
      this.form?.reset();
      this.toggleViews(true);
    });
  }

  toggleViews(showForm) {
    if (!this.form || !this.results) return;
    if (showForm) {
      this.form.classList.remove('hidden');
      this.results.classList.add('hidden');
      this.help.classList.remove('hidden');
    } else {
      this.form.classList.add('hidden');
      this.results.classList.remove('hidden');
      this.help.classList.add('hidden');
    }
  }

  buildQuery() {
    const formData = new FormData(this.form);
    const params = new URLSearchParams();

    const city = (formData.get('city') || '').toString().trim();
    const state = (formData.get('state') || '').toString().trim();
    const zip = (formData.get('zip') || '').toString().trim();
    const distance = (formData.get('distance') || '5').toString().trim();
    const brands = (formData.get('brands') || 'Silver Oak, Twomey').toString();
    const premises = (formData.get('premises') || 'On, Off').toString();

    if (brands) params.set('brands', brands);
    if (premises) params.set('premises', premises);
    if (distance) params.set('distance', distance);
    if (city) params.set('city', city);
    if (state) params.set('state', state);
    if (zip) params.set('zip', zip);

    return { params, city, state, zip };
  }

  async handleSubmit() {
    const { params, city, state, zip } = this.buildQuery();
    if (!this.validateRequired()) {
      return;
    }
    const summaryParts = [];
    if (city) summaryParts.push(city);
    if (state) summaryParts.push(state);
    if (zip) summaryParts.push(zip);
    this.summary.textContent = summaryParts.length ? `Results for ${summaryParts.join(', ')}` : 'Results';

    let endpointUrl = this.getAttribute("endpoint");
    if (endpointUrl) {
      endpointUrl = String(endpointUrl).trim().replace(/\/$/, "");
    } else {
      endpointUrl = "https://winelocator.silveroak.com";
    }

    const url = `${endpointUrl}/v1/silveroak/find-our-wines?${params.toString()}`;
    let data = null;
    try {
      const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('Request failed');
      data = await res.json();
    } catch (e) {
      this.renderError('Unable to fetch results at this time. Please try again later.');
      return;
    }

    const results = Array.isArray(data?.data) ? data.data : [];
    this.renderResults(results);
    this.toggleViews(false);
  }

  validateRequired() {
    const errorBox = this.querySelector('#wine-locator-errors');
    const errorText = errorBox?.querySelector('p');
    const atLeastOneRequired = ['city', 'state', 'zip'];
    const missing = [];

    // clear previous errors
    atLeastOneRequired.forEach((key) => {
      const underline = this.querySelector(`[data-underline="${key}"]`);
      underline?.classList.remove('border-[var(--color-red)]');
    });

    atLeastOneRequired.forEach((key) => {
      const input = this.form.querySelector(`[data-field="${key}"]`);
      const label = input?.getAttribute('data-label') || key;
      const value = (input?.value || '').toString().trim();
      if (!value) {
        missing.push(label);
      }
    });

    if (missing.length === atLeastOneRequired.length) {
      if (errorBox && errorText) {
        errorText.textContent = `Please fill out at least one: ${missing.join(', ')}`;
        errorBox.classList.remove('hidden');
      }
      return false;
    }

    if (errorBox) errorBox.classList.add('hidden');
    return true;
  }

  renderError(message) {
    this.list.innerHTML = `<p class="f0 text-[var(--color-red)]">${message}</p>`;
    this.toggleViews(false);
  }

  renderResults(items) {
    if (!items.length) {
      this.list.innerHTML = `<p class="f0">No results found. Please adjust your search.</p>`;
      return;
    }

    const formatPremise = (p) => {
      const val = (p || '').toString().trim().toUpperCase();
      if (val.startsWith('ON')) return 'Restaurant';
      if (val.startsWith('OFF')) return 'Retail Store';
      return val || 'Location';
    };

    const padIndex = (i) => String(i + 1).padStart(2, '0');

    const rows = items.map((item, i) => {
      const name = item.AccountName || '';
      const miles = typeof item.Distance === 'number' ? item.Distance.toFixed(2) : '';
      const address = [item.Street, item.City, item.State, item.Zip].filter(Boolean).join(' ');
      const mapLink = item.mapLink || '#';
      const type = formatPremise(item.Premise);
      const brand = item.WineryBrand || '';

      return `
        <div class="flex items-start gap-4 border-b border-[var(--color-morning-mist)] pb-4">
          <div class="relative flex h-8 w-8 shrink-0 items-center justify-center">
            <svg width="24" height="31" viewBox="0 0 24 31" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute inset-0 h-full w-full object-contain opacity-20">
                <path d="M24 11.7678C24 17.6552 15.5871 27.4466 12.8496 30.4769C12.3899 30.9857 11.6101 30.9857 11.1503 30.4769C8.41268 27.4475 0 17.662 0 11.8101C0 4.82096 5.37258 0.199219 12 0.199219C18.6274 0.199219 24 5.37863 24 11.7678Z" fill="#202124"/>
            </svg>
            <span class="fn2 relative top-[-4px]">${padIndex(i)}</span>
          </div>
          <div class="flex-1">
            <span class="f1 block">${name}: ${miles} miles</span>
            <p class="f0">${address} | <a class="underline" href="${mapLink}" target="_blank" rel="noopener">Map</a></p>
            <p class="f0">${type}  |  Wine: ${brand}</p>
          </div>
        </div>
      `;
    }).join('');

    this.list.innerHTML = rows;
  }
}

customElements.define('wine-locator', WineLocator);

  } catch(e) { console.error(e); }
})();
})();
